document.addEventListener('click', async (event) => {
  const button = event.target.closest('.product-form__buy-now');
  if (!button || button.disabled || button.classList.contains('btn--loading')) return;

  const form = document.getElementById(button.dataset.formId);
  if (!form) return;

  const addButton = form.querySelector('[name="add"]');
  if (addButton && addButton.disabled) return;

  const variantInput = form.querySelector('.product-variant-id');
  if (!variantInput || variantInput.disabled || !variantInput.value) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const errorMessage = form.querySelector('.product-form__error-message');

  if (errorMessage) {
    errorMessage.hidden = true;
    errorMessage.textContent = '';
  }

  button.classList.add('btn--loading');

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || '');
    }

    window.location.href = `${root}checkout`;
  } catch (error) {
    button.classList.remove('btn--loading');

    if (errorMessage && error.message) {
      errorMessage.textContent = error.message;
      errorMessage.hidden = false;
    }
  }
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('.product-form__buy-now.btn--loading').forEach((button) => {
    button.classList.remove('btn--loading');
  });
});